<template>
    <div class="c-color-selector u-spacer--2">
        <BaseRadioButtonGroup
            :id="id"
            :name="id"
            :styleType="BUTTON_STYLE_TYPES.INLINE_TILE"
            :radioButtonItems="formattedOptions"
            :checkedItem="selectedChoice?.color?.code"
            @update:model-value="updateSelectedColor"
        >
            <template #default="{ id: slotId, isSelected, value: radioboxValue }">
                <ColorCardButton
                    :id="slotId"
                    :key="selectedChoice?.choiceId"
                    :isSelected="isSelected"
                    :isAvailable="getOptionByValue(radioboxValue)?.available"
                    :color="getOptionByValue(radioboxValue)?.color"
                    class="c-color-selector__button u-text--gray"
                />
            </template>
        </BaseRadioButtonGroup>
    </div>
</template>

<script setup>
import { computed } from 'vue';

import { BUTTON_STYLE_TYPES } from '~coreModules/core/js/constants';

import ColorCardButton from '~modules/core/components/ui/buttons/ColorCardButton.vue';
import BaseRadioButtonGroup from '~coreModules/core/components/ui/form-elements/radios/BaseRadioButtonGroup.vue';

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    choices: {
        type: Array,
        required: true,
    },
    selectedChoice: {
        type: Object,
        required: true,
    },
    sizeCodeAvailibilityByChoiceId: {
        type: Object,
        required: true,
    },
    selectedSkuSizeCode: {
        type: String,
        default: '',
    },
    updateSelectedColor: {
        type: Function,
        required: true,
    },
});

const formattedOptions = computed(() => (
    (props.choices || []).map(value => ({
        ...value,
        label: value.color?.displayName,
        value: value.color?.code,
    }))
));

function choiceHasAvailibilityForSizeCode(choiceId) {
    return !props.selectedSkuSizeCode ||
        props.sizeCodeAvailibilityByChoiceId[choiceId]?.includes(props.selectedSkuSizeCode);
}

const shapedOptions = computed(() => (
    formattedOptions.value.map(option => ({
        ...option,
        available: choiceHasAvailibilityForSizeCode(option.choiceId),
    })).reduce((acc, option) => Object.assign(acc, {
        [option.color.code]: option,
    }), {})
));

function getOptionByValue(value) {
    return shapedOptions.value[value] || {};
}

</script>

<style lang="scss">
.c-color-selector {
    $this: &;

    input {
        &[data-focus-visible-added]:not(:available) ~ #{$this}__button {
            outline: $focus-outline;
        }
    }
}
</style>
